import React from 'react';
import TooltipPrice from '~/App/shared/components/TooltipPrice';
import { useTranslation } from '~/Locale';
import { locale as domainLocale } from '~/config/public/environment';

interface Props {
  title: string;
  price?: number | null;
}

export const PriceInEUR = ({ title, price }: Props) => {
  const { t } = useTranslation();

  if (domainLocale === 'sv') {
    return null;
  }

  if (!price) {
    return null;
  }

  return (
    <TooltipPrice
      title={title}
      price={price}
      currency={t('EUR')}
      explanation={t(
        'Approximate conversion from SEK to EUR based on current exchange rate. Final price in EUR may vary.'
      )}
    />
  );
};
